import { Box } from '@chakra-ui/react';
import { tableList } from './const';
import SearchBar from '@components/searchBar';
import TableAddItem from '@components/TableAddItem';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { useGetInfiniteProductList, useGetProductList } from '@pages/ConsumerPromotion/hooks/query/useGetProductList';
import { debounce, some } from 'lodash';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { useEffect } from 'react';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePagination';

export default function Table() {
    const stateEdit = useEditDetail();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const allData = usePaginationStore((s) => s.data);
    const page = usePaginationStore((s) => s.page);
    const limit = usePaginationStore((s) => s.limit);
    const pageCount = Math.max(1, Math.ceil(allData.length / limit));
    const { setData, setLimit, setPage, editItem } = usePaginationStore();

    const start = (page - 1) * limit;
    const paginatedData = allData.slice(start, start + limit);
    const total = usePaginationStore((s) => s.total());

    const { data, isLoading } = useGetProductList({
        id: stateEdit?.id,
        limit: 999999999,
        page: stateEdit?.page,
        search: stateEdit?.searchSku,
    });

    const {
        data: infiniteData,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        isLoading: isLoadingInfiniteData,
    } = useGetInfiniteProductList(stateEdit?.searchMasterDataSku);

    const onSelectItem = (value) => {
        let exists;

        if (value.is_basepack) {
            value.id = value.id ?? crypto.randomUUID();
            exists = some(allData, { name: value.name });
        } else {
            exists = some(allData, { sku_id: value.sku_id });
        }

        if (stateEdit?.editingRow) {
            const isSameRow = stateEdit.editingRow.is_basepack
                ? stateEdit.editingRow.name === value.name
                : stateEdit.editingRow.sku_id === value.sku_id;

            if (exists && !isSameRow) {
                return onChangeSnackbarNotification({
                    status: 'error',
                    description: 'Produk sudah ditambahkan!',
                    duration: 3,
                });
            }

            editItem(stateEdit.editingRow.id, value);
            stateEdit.set({ editingRow: null });
            return;
        }

        if (exists) {
            return onChangeSnackbarNotification({
                status: 'error',
                description: 'Produk sudah ditambahkan!',
                duration: 3,
            });
        }

        setData([...allData, value]);
    };

    const onSearchItem = debounce((value) => {
        stateEdit.set({
            searchSku: '',
            searchMasterDataSku: value,
        });
    }, 500);

    const handleSearchTable = debounce((e) => {
        const searchTable = e.target.value.toLowerCase();

        stateEdit.set({ searchSku: searchTable });
    }, 500);

    const onChangeLimit = (e) => {
        setLimit(e.target.value);
    };

    const handlePageChange = ({ selected }) => {
        setPage(selected + 1);
    };

    useEffect(() => {
        if (data) {
            setData(data?.page_data);
        }
    }, [data]);

    return (
        <Box>
            <SearchBar placeholder={'Cari nama atau ID produk'} mb={'24px'} onChange={handleSearchTable} />

            <TableAddItem
                tableList={tableList}
                data={paginatedData}
                isLoading={isLoading}
                // * props add item to table
                queryAddItem={infiniteData}
                isLoadingQueryItem={isLoadingInfiniteData}
                isAddItem={stateEdit.isEdit}
                onSearchItem={onSearchItem}
                onSelectItem={onSelectItem}
                groupBy={(item) => (item?.is_basepack ? 'BASEPACK' : 'PRODUK SATUAN')}
                editingRow={stateEdit?.editingRow}
                fetchNextPage={fetchNextPage}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                // * props pagination
                totalData={total}
                limit={limit}
                page={page}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                onChangeLimit={onChangeLimit}
            />
        </Box>
    );
}
